import React from 'react';
import { X } from 'lucide-react';

type VenueChangingModalProps = {
  isOpen: boolean;
  onClose: () => void;
  currentVenueName: string | null;
  newVenueName: string;
  onKeepCurrent: () => void;
  onSwitchVenue: () => void;
};

export default function VenueChangingModal({
  isOpen,
  onClose,
  currentVenueName,
  newVenueName,
  onKeepCurrent,
  onSwitchVenue,
}: VenueChangingModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-zinc-800 rounded-lg shadow-lg max-w-md w-full animate-in fade-in duration-200">
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-xl font-semibold text-white">Change Venue?</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <p className="text-gray-300 mb-6">
            Your cart currently contains items from {currentVenueName}. 
            Would you like to clear your cart and add items from {newVenueName} instead?
          </p>
          <div className="flex justify-end space-x-4">
            <button
              onClick={onKeepCurrent}
              className="px-4 py-2 border border-gray-600 text-gray-300 rounded-md hover:bg-gray-700 transition-colors"
            >
              Keep Current Cart
            </button>
            <button
              onClick={onSwitchVenue}
              className="px-4 py-2 bg-yellow-400 text-black rounded-md hover:bg-yellow-300 transition-colors"
            >
              Switch to {newVenueName}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}